import { log } from '../../log/OpenPixLogger.tsx';
import { generateBRCodeStatic } from '../generateBRCodeStatic.ts';
import { store } from '../OpenPixStore.tsx';

type PixStaticPayload = {
  key: string;
  value: string;
  name: string;
  reference: string;
};
// $openpix.push(["static", { key: 'cpf', value: 100, name: 'Vendedor', reference: 'Doacao' })
export const pixStatic = (args: PixStaticPayload) => {
  const { key, value, name, reference } = args;

  const emv = generateBRCodeStatic({
    key,
    amount: value,
    name,
    reference,
  });

  // eslint-disable-next-line
  log({
    emv,
  });

  store.setState({
    isOpen: true,
    brCode: emv,
    success: false,
    isTemp: false,
  });
};
